// OcipError.jsx  (GrowattError)
import "./OcipError.css";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

const GrowattError = ({ SelInverter }) => {
  const Iv_list = useSelector((state) => state.Iv_list || {});
  const ivData  = useSelector((state) => state.ivData  || {});
  const [index, setIndex] = useState(null);

  // 선택 인버터의 index 구하기
  useEffect(() => {
    if (Iv_list.seq && Array.isArray(Iv_list.seq)) {
      const i = Iv_list.seq.findIndex((seq) => seq === SelInverter);
      if (i !== -1) setIndex(i);
    }
  }, [Iv_list, SelInverter]);

  // 필드 값 안전하게 꺼내기: 배열(인버터별)도, 단일값도 대응
  const getField = (name) => {
    const v = ivData?.[name];
    if (Array.isArray(v)) {
      return index != null ? v[index] : undefined;
    }
    return v;
  };

  // 사진처럼 2열 구성
  const itemsLeft = [
    { label: "인버터 동작", key: "state" },  // state: 1=정상
    { label: "105 (Error0)", key: "Pfault" },
    { label: "106 (Error1)", key: "fault0" },
    { label: "107 (Error2)", key: "fault1" },
  ];
  const itemsRight = [
    { label: "110 (Error3)", key: "fault2" },
    { label: "111 (Error4)", key: "fault3" },
    { label: "112 (Error5)", key: "fault4" },
  ];

  // 이상 판정: state는 1이 정상, 그 외는 0이 정상
  const isAbnormal = (item, value) => {
    const n = Number(value);
    if (!Number.isFinite(n)) return false;
    if (item.key === "state") return n !== 1; // state만 1이 정상
    return n !== 0;                            // 나머지는 0이 정상
  };

  const RowItem = ({ item }) => {
    const value = getField(item.key);
    const abnormal = isAbnormal(item, value);
    return (
      <div className="status-item">
        <span className="status-value">
          {item.label}: {value ?? "-"}
        </span>
        <span className={abnormal ? "blinking-icon" : ""}>
          {abnormal ? "🔴" : "🟢"}
        </span>
      </div>
    );
  };

  return (
    <div className="status-list-container">
      <div className="status-list">
        {itemsLeft.map((it) => (
          <RowItem key={it.key} item={it} />
        ))}
        {itemsRight.map((it) => (
          <RowItem key={it.key} item={it} />
        ))}
      </div>
    </div>
  );
};

export default GrowattError;
